/** Presentation fallback for page titles missing Spanish in the projection. */
const spanish: Record<string, string> = {
  "Your work": "Su trabajo",
  "Work": "Trabajo",
  "Hiring and pay": "Contratación y remuneración",
  "Dates and travel": "Fechas y viaje",
  "Credits": "Créditos",
  "Professional profile": "Perfil profesional",
  "Career": "Trayectoria profesional",
  "Support experience": "Experiencia de apoyo",
  "Professional evidence": "Documentación profesional",
};

export function pageTitle(value: { en?: string; es?: string; text?: string } | string | undefined, locale: string) {
  if (typeof value === "string") return locale === "es" ? spanish[value] ?? value : value;
  return value?.[locale as "en" | "es"] ?? (locale === "es" ? spanish[value?.en ?? ""] : undefined) ?? value?.en ?? value?.text ?? "";
}
